<h1>404</h1>
<button (click)="navigateBack()" class="btn btn-primary" type="button">{{ "NOT-FOUND.BACK" | translate }}</button>
